module.exports = __webpack_public_path__ + "img/lnk-dash-footer.b32e7d44.svg";